module.exports = __webpack_public_path__ + "img/rec_1.fab069ad.png";